import { useEffect, useState } from "react";
import { Heart } from "lucide-react";
import { api } from "@/lib/api";

export default function DonationWall() {
  const [wall, setWall] = useState(null);

  useEffect(() => {
    api.get("/donations/wall").then((r) => setWall(r.data)).catch(() => setWall(null));
  }, []);

  if (!wall || wall.count === 0) return null;
  const items = [...wall.donors, ...wall.donors];

  return (
    <section data-testid="donation-wall" className="relative bg-blood text-white border-y border-white/10 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16 py-4 flex flex-col sm:flex-row sm:items-center gap-3 sm:gap-8">
        <div className="shrink-0 flex items-center gap-3">
          <Heart size={16} fill="currentColor" />
          <p className="font-mono text-[10px] uppercase tracking-[0.3em]">Respect to our supporters</p>
          <span data-testid="donation-wall-total" className="font-display font-black text-lg tabular-nums">
            ${wall.total.toLocaleString(undefined, { minimumFractionDigits: 2 })}
            <span className="font-mono text-[10px] tracking-widest ml-2 opacity-80">RAISED · {wall.count} {wall.count === 1 ? "GIFT" : "GIFTS"}</span>
          </span>
        </div>
        <div className="relative flex-1 overflow-hidden min-h-[1.5rem]" style={{ maskImage: "linear-gradient(90deg, transparent, #000 8%, #000 92%, transparent)" }}>
          <div className="flex gap-10 whitespace-nowrap animate-wall">
            {items.map((d, i) => (
              <span key={i} data-testid={i < wall.donors.length ? `donation-wall-item-${i}` : undefined} className="font-mono text-xs">
                <span className="font-display font-bold uppercase text-sm">{d.name}</span>
                {d.message ? <span className="opacity-90"> — “{d.message}”</span> : null}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
